import clsx from "clsx";
import React from "react";

export const Button = ({
  onClick,
  disabled,
  children,
  classes,
  title,
  type,
}: {
  onClick?: (e: React.SyntheticEvent) => void;
  disabled?: boolean;
  children: React.ReactNode;
  classes?: string;
  title?: string;
  type?: "button" | "submit" | "reset";
}) => {
  return (
    <button
      className={clsx(
        "p-2 rounded cursor-pointer",
        "bg-stone-400 dark:bg-stone-700",
        {
          "opacity-50 cursor-not-allowed": disabled,
          "hover:bg-stone-300 dark:hover:bg-stone-600 active:bg-stone-500 dark:active:bg-stone-600":
            !disabled,
        },
        classes,
      )}
      onClick={onClick}
      disabled={disabled}
      title={title}
      type={type}
    >
      {children}
    </button>
  );
};
